import { OnSchedTemplates } from "../../OnSchedTemplates"
import { OnSchedOnChange } from ".";


export const OnChangeCountry = (element, option, provinces) => {
  var elCountryBtn = document.getElementById('onsched-country-button');
  var elCountryInput = document.getElementById('onsched-country-hidden-input');
  let elCountrySelected = document.querySelector(`[data-country="${option.dataset.country}"]`);
  let countrySelectedData = {...elCountrySelected.dataset};
  
  Object.keys(countrySelectedData).map((countryData, idx) => elCountryBtn.dataset[countryData] = Object.values(countrySelectedData)[idx]);
  Object.keys(countrySelectedData).map((countryData, idx) => elCountryInput.dataset[countryData] = Object.values(countrySelectedData)[idx]);

  elCountryBtn.innerText = countrySelectedData.country;
  elCountryInput.value = countrySelectedData.code;
  
  var elProvList = document.getElementById('onsched-province-options');
  var newProvs = provinces.filter(p => p.country === countrySelectedData.code);
  
  var elProvBtn = document.getElementById('onsched-province-button');
  var elProvInput = document.getElementById('onsched-province-hidden-input');

  Object.keys(newProvs[0]).map((provData, idx) => elProvBtn.dataset[provData] = Object.values(newProvs[0])[idx]);
  Object.keys(newProvs[0]).map((provData, idx) => elProvInput.dataset[provData] = Object.values(newProvs[0])[idx]);

  elProvBtn.innerText = newProvs[0].name
  elProvList.innerHTML = OnSchedTemplates.ProvinceOptions(newProvs);

  var elProvOptions = document.querySelectorAll('.onsched-province-option');
  var elProvSearch = document.getElementById('onsched-province-search-input');

  elProvOptions.forEach(option => option.onclick = () => OnSchedOnChange.OnChangeProvince(element, option, provinces));

  elProvSearch.onkeyup = e => {
    elProvList.innerHTML = '';

    [...elProvOptions].filter(opt => opt.innerText.toLowerCase().includes(e.target.value.toLowerCase()))
                    .forEach(opt => elProvList.appendChild(opt))
  }
  
  document.getElementById('onsched-country').classList.remove('active');
}
